/* i18n — 5 supported languages. Keep keys flat and pragmatic. */
export const SUPPORTED_LANGS = [
  { code: "en", label: "English", short: "EN" },
  { code: "es", label: "Español", short: "ES" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "pt", label: "Português", short: "PT" },
  { code: "ht", label: "Kreyòl", short: "HT" },
];

const T = {
  en: {
    "nav.dashboard": "Command Center",
    "nav.projects": "Projects",
    "nav.tickets": "Support",
    "nav.hardware": "Hardware Ledger",
    "nav.calculator": "Calculator",
    "nav.documents": "Documents",
    "nav.renewals": "Renewals",
    "nav.login": "Sign in",
    "nav.signup": "Request Access",
    "nav.logout": "Sign out",
    "landing.badge": "Engineering Operations · Access Control · VMS · Radar",
    "landing.hero.title": "The operational command center for high-end security integrators.",
    "landing.hero.subtitle": "B2BProblemSolver unifies project tracking, hardware compliance, and AI-powered multilingual support into a single white-labeled platform — built for Kantech, Avigilon, Lenel OnGuard and Magos Radar teams from Santiago to Montreal.",
    "landing.cta.primary": "Enter Command Center",
    "landing.cta.secondary": "Request access",
    "landing.services.kicker": "Disciplines",
    "landing.services.title": "Three systems. One operational canopy.",
    "landing.service.ac": "Access Control",
    "landing.service.ac.desc": "Kantech KT-400, KT-1, Lenel OnGuard deployments, firmware governance and commissioning trails.",
    "landing.service.vms": "Video Management",
    "landing.service.vms.desc": "Avigilon ACC Enterprise rollouts, analytics tuning, and bandwidth/storage modeling.",
    "landing.service.radar": "Perimeter Radar",
    "landing.service.radar.desc": "Magos SR-500 / SR-1000 perimeter integration with access control and VMS triggers.",
    "landing.presence.kicker": "Operational footprint",
    "landing.presence.title": "Engineered continuity across four hubs.",
    "landing.features.kicker": "Modules",
    "landing.feature1.title": "Client Command Center",
    "landing.feature1.desc": "Real-time project status across Access Control, VMS and Radar engagements.",
    "landing.feature2.title": "AI Ticketing Engine",
    "landing.feature2.desc": "Gemini-3 powered technical replies in 5 languages with auto-matched manuals.",
    "landing.feature3.title": "Hardware Ledger",
    "landing.feature3.desc": "Firmware versions, license expiry and health across every deployed asset.",
    "landing.feature4.title": "Document Generator",
    "landing.feature4.desc": "White-labeled Technical Commissioning Reports & Project Blueprints — one click.",
    "landing.feature5.title": "Infrastructure Calculator",
    "landing.feature5.desc": "Bandwidth, storage, power and UPS runtime for any camera fleet.",
    "landing.feature6.title": "RBAC & Webhooks",
    "landing.feature6.desc": "Standard & Premium client tiers, API hooks for CRM and ERP automation.",
    "landing.footer": "B2BProblemSolver LLC · All systems engineered for continuity.",
    "auth.login.title": "Sign in to Command Center",
    "auth.login.subtitle": "Secure access for staff, contractors and clients.",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.signin": "Sign in",
    "auth.google": "Continue with Google (Corporate)",
    "auth.noaccount": "Need an account?",
    "auth.register": "Request access",
    "auth.haveaccount": "Already a client?",
    "auth.name": "Full name",
    "auth.company": "Company",
    "auth.register.title": "Request platform access",
    "auth.register.subtitle": "Create a client account to open tickets, track projects and download technical documentation.",
    "auth.register.submit": "Create account",
    "dashboard.title": "Command Center",
    "dashboard.subtitle": "Live operational snapshot across every engagement.",
    "dashboard.kpi.projects": "Active Projects",
    "dashboard.kpi.tickets": "Support Tickets",
    "dashboard.kpi.assets": "Hardware Assets",
    "dashboard.kpi.critical": "Critical Alerts",
    "dashboard.projects.recent": "Projects by System",
    "dashboard.tickets.recent": "Recent Tickets",
    "dashboard.hardware.health": "Hardware Health",
    "projects.title": "Projects",
    "projects.new": "New project",
    "projects.columns.name": "Project",
    "projects.columns.system": "System",
    "projects.columns.site": "Site",
    "projects.columns.status": "Status",
    "projects.columns.progress": "Progress",
    "projects.columns.engineer": "Lead",
    "tickets.title": "Support · AI Response Engine",
    "tickets.new": "New ticket",
    "tickets.empty": "No tickets yet — open your first request.",
    "tickets.form.subject": "Subject",
    "tickets.form.body": "Describe the issue (be technical, include firmware, model, site).",
    "tickets.form.system": "System",
    "tickets.form.priority": "Priority",
    "tickets.form.language": "Response language",
    "tickets.form.submit": "Open ticket · generate AI reply",
    "tickets.ai_reply": "AI Response",
    "tickets.customer": "Customer",
    "tickets.staff": "Staff",
    "tickets.reply": "Post reply",
    "tickets.reply.placeholder": "Write your reply…",
    "tickets.use_ai": "Rewrite with AI",
    "hardware.title": "Hardware Ledger",
    "hardware.new": "Add asset",
    "hardware.columns.vendor": "Vendor",
    "hardware.columns.model": "Model",
    "hardware.columns.serial": "Serial",
    "hardware.columns.site": "Site",
    "hardware.columns.firmware": "Firmware",
    "hardware.columns.license": "License expiry",
    "hardware.columns.status": "Status",
    "calc.title": "Infrastructure Calculator",
    "calc.subtitle": "Premium · Bandwidth, storage and power for any camera fleet.",
    "calc.cameras": "Cameras",
    "calc.resolution": "Resolution",
    "calc.fps": "Frames / sec",
    "calc.retention": "Retention (days)",
    "calc.compression": "Compression",
    "calc.radar": "Radar sensors",
    "calc.readers": "Access readers",
    "calc.compute": "Compute infrastructure",
    "calc.gated": "Premium clients only. Contact us to upgrade.",
    "calc.out.bandwidth": "Total bandwidth",
    "calc.out.storage": "Storage over retention",
    "calc.out.power": "Total power draw",
    "calc.out.switches": "24-port PoE switches",
    "docs.title": "Document Generator",
    "docs.subtitle": "Generate white-labeled Technical Commissioning Reports & Project Blueprints.",
    "docs.type": "Document type",
    "docs.type.commissioning": "Technical Commissioning Report",
    "docs.type.blueprint": "Project Blueprint",
    "docs.generate": "Generate PDF",
    "docs.download": "Download",
    "common.operational": "Operational",
    "common.warning": "Warning",
    "common.critical": "Critical",
    "common.offline": "Offline",
    "common.planning": "Planning",
    "common.in_progress": "In progress",
    "common.completed": "Completed",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.submit": "Submit",
    "common.language": "Language",
    "renewals.title": "License Renewal Pipeline",
    "renewals.subtitle": "Auto-generate quotes and email reminders 60 / 30 / 7 days before any vendor license expires.",
    "renewals.run": "Scan & dispatch",
    "renewals.force": "Force resend",
    "renewals.send": "Send",
    "renewals.assets": "asset(s)",
    "renewals.empty": "No upcoming renewals — every license is more than 60 days from expiry.",
    "renewals.tab.pipeline": "Pipeline",
    "renewals.tab.history": "History",
  },
  es: {
    "nav.dashboard": "Centro de Mando",
    "nav.projects": "Proyectos",
    "nav.tickets": "Soporte",
    "nav.hardware": "Inventario",
    "nav.calculator": "Calculadora",
    "nav.documents": "Documentos",
    "nav.renewals": "Renovaciones",
    "nav.login": "Iniciar sesión",
    "nav.signup": "Solicitar acceso",
    "nav.logout": "Cerrar sesión",
    "landing.badge": "Operaciones de Ingeniería · Control de Acceso · VMS · Radar",
    "landing.hero.title": "El centro de mando operacional para integradores de seguridad de alta gama.",
    "landing.hero.subtitle": "B2BProblemSolver unifica seguimiento de proyectos, cumplimiento de hardware y soporte multilingüe con IA en una plataforma white-label — construida para equipos Kantech, Avigilon, Lenel OnGuard y Magos Radar de Santiago a Montreal.",
    "landing.cta.primary": "Entrar al Centro de Mando",
    "landing.cta.secondary": "Solicitar acceso",
    "landing.services.kicker": "Disciplinas",
    "landing.services.title": "Tres sistemas. Una cubierta operativa.",
    "landing.service.ac": "Control de Acceso",
    "landing.service.ac.desc": "Implementaciones Kantech KT-400, KT-1 y Lenel OnGuard, gobernanza de firmware y trazabilidad de comisionamiento.",
    "landing.service.vms": "Gestión de Video",
    "landing.service.vms.desc": "Despliegues Avigilon ACC Enterprise, sintonización de analíticas y modelado de ancho de banda/almacenamiento.",
    "landing.service.radar": "Radar Perimetral",
    "landing.service.radar.desc": "Integración perimetral Magos SR-500 / SR-1000 con control de acceso y VMS.",
    "landing.presence.kicker": "Huella operativa",
    "landing.presence.title": "Continuidad de ingeniería en cuatro hubs.",
    "landing.features.kicker": "Módulos",
    "landing.feature1.title": "Centro de Mando del Cliente",
    "landing.feature1.desc": "Estado de proyectos en tiempo real para Access Control, VMS y Radar.",
    "landing.feature2.title": "Motor de Tickets con IA",
    "landing.feature2.desc": "Respuestas técnicas con Gemini-3 en 5 idiomas con manuales autoasociados.",
    "landing.feature3.title": "Inventario de Hardware",
    "landing.feature3.desc": "Versiones de firmware, vencimiento de licencias y salud de cada activo.",
    "landing.feature4.title": "Generador de Documentos",
    "landing.feature4.desc": "Reportes de Comisionamiento y Planos de Proyecto white-label en un clic.",
    "landing.feature5.title": "Calculadora de Infraestructura",
    "landing.feature5.desc": "Ancho de banda, almacenamiento, potencia y autonomía UPS para cualquier flota de cámaras.",
    "landing.feature6.title": "RBAC y Webhooks",
    "landing.feature6.desc": "Niveles Standard y Premium, hooks API para automatizar CRM y ERP.",
    "landing.footer": "B2BProblemSolver LLC · Todos los sistemas diseñados para continuidad.",
    "auth.login.title": "Acceder al Centro de Mando",
    "auth.login.subtitle": "Acceso seguro para staff, contratistas y clientes.",
    "auth.email": "Correo",
    "auth.password": "Contraseña",
    "auth.signin": "Ingresar",
    "auth.google": "Continuar con Google (Corporativo)",
    "auth.noaccount": "¿Sin cuenta?",
    "auth.register": "Solicitar acceso",
    "auth.haveaccount": "¿Ya eres cliente?",
    "auth.name": "Nombre completo",
    "auth.company": "Empresa",
    "auth.register.title": "Solicitar acceso a la plataforma",
    "auth.register.subtitle": "Crea una cuenta de cliente para abrir tickets, seguir proyectos y descargar documentación.",
    "auth.register.submit": "Crear cuenta",
    "dashboard.title": "Centro de Mando",
    "dashboard.subtitle": "Instantánea operativa en vivo de cada proyecto.",
    "dashboard.kpi.projects": "Proyectos Activos",
    "dashboard.kpi.tickets": "Tickets",
    "dashboard.kpi.assets": "Activos",
    "dashboard.kpi.critical": "Alertas Críticas",
    "dashboard.projects.recent": "Proyectos por Sistema",
    "dashboard.tickets.recent": "Tickets Recientes",
    "dashboard.hardware.health": "Salud de Hardware",
    "projects.title": "Proyectos",
    "projects.new": "Nuevo proyecto",
    "projects.columns.name": "Proyecto",
    "projects.columns.system": "Sistema",
    "projects.columns.site": "Sitio",
    "projects.columns.status": "Estado",
    "projects.columns.progress": "Progreso",
    "projects.columns.engineer": "Líder",
    "tickets.title": "Soporte · Motor de IA",
    "tickets.new": "Nuevo ticket",
    "tickets.empty": "Aún no hay tickets — abre el primero.",
    "tickets.form.subject": "Asunto",
    "tickets.form.body": "Describe el problema (técnico, con firmware, modelo, sitio).",
    "tickets.form.system": "Sistema",
    "tickets.form.priority": "Prioridad",
    "tickets.form.language": "Idioma de respuesta",
    "tickets.form.submit": "Abrir ticket · generar respuesta IA",
    "tickets.ai_reply": "Respuesta de IA",
    "tickets.customer": "Cliente",
    "tickets.staff": "Staff",
    "tickets.reply": "Enviar respuesta",
    "tickets.reply.placeholder": "Escribe tu respuesta…",
    "tickets.use_ai": "Reescribir con IA",
    "hardware.title": "Inventario de Hardware",
    "hardware.new": "Nuevo activo",
    "hardware.columns.vendor": "Fabricante",
    "hardware.columns.model": "Modelo",
    "hardware.columns.serial": "Serial",
    "hardware.columns.site": "Sitio",
    "hardware.columns.firmware": "Firmware",
    "hardware.columns.license": "Licencia",
    "hardware.columns.status": "Estado",
    "calc.title": "Calculadora de Infraestructura",
    "calc.subtitle": "Premium · Ancho de banda, almacenamiento y potencia.",
    "calc.cameras": "Cámaras",
    "calc.resolution": "Resolución",
    "calc.fps": "FPS",
    "calc.retention": "Retención (días)",
    "calc.compression": "Compresión",
    "calc.radar": "Sensores radar",
    "calc.readers": "Lectores de acceso",
    "calc.compute": "Calcular",
    "calc.gated": "Solo clientes Premium. Contáctanos para mejorar.",
    "calc.out.bandwidth": "Ancho de banda total",
    "calc.out.storage": "Almacenamiento por retención",
    "calc.out.power": "Potencia total",
    "calc.out.switches": "Switches PoE 24p",
    "docs.title": "Generador de Documentos",
    "docs.subtitle": "Reportes de Comisionamiento y Planos de Proyecto white-label.",
    "docs.type": "Tipo de documento",
    "docs.type.commissioning": "Reporte Técnico de Comisionamiento",
    "docs.type.blueprint": "Plano de Proyecto",
    "docs.generate": "Generar PDF",
    "docs.download": "Descargar",
    "common.operational": "Operativo",
    "common.warning": "Alerta",
    "common.critical": "Crítico",
    "common.offline": "Sin conexión",
    "common.planning": "Planificación",
    "common.in_progress": "En curso",
    "common.completed": "Completado",
    "common.cancel": "Cancelar",
    "common.save": "Guardar",
    "common.submit": "Enviar",
    "common.language": "Idioma",
    "renewals.title": "Pipeline de Renovación de Licencias",
    "renewals.subtitle": "Genera cotizaciones y envía recordatorios automáticos 60 / 30 / 7 días antes del vencimiento.",
    "renewals.run": "Escanear y enviar",
    "renewals.force": "Reenviar",
    "renewals.send": "Enviar",
    "renewals.assets": "activo(s)",
    "renewals.empty": "Sin renovaciones próximas — todas las licencias tienen más de 60 días de vigencia.",
    "renewals.tab.pipeline": "Pipeline",
    "renewals.tab.history": "Historial",
  },
  fr: {
    "nav.dashboard": "Centre de Commandement",
    "nav.projects": "Projets",
    "nav.tickets": "Support",
    "nav.hardware": "Parc matériel",
    "nav.calculator": "Calculateur",
    "nav.documents": "Documents",
    "nav.renewals": "Renouvellements",
    "nav.login": "Connexion",
    "nav.signup": "Demander l'accès",
    "nav.logout": "Déconnexion",
    "landing.badge": "Opérations d'Ingénierie · Contrôle d'Accès · VMS · Radar",
    "landing.hero.title": "Le centre de commandement opérationnel pour les intégrateurs de sécurité haut de gamme.",
    "landing.hero.subtitle": "B2BProblemSolver unifie le suivi de projet, la conformité matérielle et le support IA multilingue dans une plateforme en marque blanche — conçue pour les équipes Kantech, Avigilon, Lenel OnGuard et Magos Radar de Santiago à Montréal.",
    "landing.cta.primary": "Entrer au Centre de Commandement",
    "landing.cta.secondary": "Demander l'accès",
    "landing.services.kicker": "Disciplines",
    "landing.services.title": "Trois systèmes. Une canopée opérationnelle.",
    "landing.service.ac": "Contrôle d'Accès",
    "landing.service.ac.desc": "Déploiements Kantech KT-400, KT-1, Lenel OnGuard, gouvernance firmware et traçabilité.",
    "landing.service.vms": "Gestion Vidéo",
    "landing.service.vms.desc": "Déploiements Avigilon ACC Enterprise, tuning d'analytiques et modélisation bande passante/stockage.",
    "landing.service.radar": "Radar Périmétrique",
    "landing.service.radar.desc": "Intégration périmétrique Magos SR-500 / SR-1000 avec triggers contrôle d'accès et VMS.",
    "landing.presence.kicker": "Empreinte opérationnelle",
    "landing.presence.title": "Continuité d'ingénierie à travers quatre hubs.",
    "landing.features.kicker": "Modules",
    "landing.feature1.title": "Centre de Commandement Client",
    "landing.feature1.desc": "État des projets en temps réel pour Access Control, VMS et Radar.",
    "landing.feature2.title": "Moteur de Tickets IA",
    "landing.feature2.desc": "Réponses techniques Gemini-3 en 5 langues avec manuels auto-associés.",
    "landing.feature3.title": "Parc Matériel",
    "landing.feature3.desc": "Versions firmware, expiration de licences et santé de chaque actif.",
    "landing.feature4.title": "Générateur de Documents",
    "landing.feature4.desc": "Rapports de Commissioning et Plans de Projet en marque blanche, en un clic.",
    "landing.feature5.title": "Calculateur d'Infrastructure",
    "landing.feature5.desc": "Bande passante, stockage, puissance et autonomie UPS pour toute flotte.",
    "landing.feature6.title": "RBAC & Webhooks",
    "landing.feature6.desc": "Niveaux Standard et Premium, hooks API pour CRM et ERP.",
    "landing.footer": "B2BProblemSolver LLC · Systèmes conçus pour la continuité.",
    "auth.login.title": "Se connecter au Centre",
    "auth.login.subtitle": "Accès sécurisé pour staff, contractants et clients.",
    "auth.email": "Email",
    "auth.password": "Mot de passe",
    "auth.signin": "Se connecter",
    "auth.google": "Continuer avec Google (Corporate)",
    "auth.noaccount": "Pas de compte ?",
    "auth.register": "Demander l'accès",
    "auth.haveaccount": "Déjà client ?",
    "auth.name": "Nom complet",
    "auth.company": "Société",
    "auth.register.title": "Demander l'accès à la plateforme",
    "auth.register.subtitle": "Créez un compte client pour ouvrir des tickets et télécharger la documentation.",
    "auth.register.submit": "Créer le compte",
    "dashboard.title": "Centre de Commandement",
    "dashboard.subtitle": "Instantané opérationnel en direct.",
    "dashboard.kpi.projects": "Projets Actifs",
    "dashboard.kpi.tickets": "Tickets",
    "dashboard.kpi.assets": "Équipements",
    "dashboard.kpi.critical": "Alertes Critiques",
    "dashboard.projects.recent": "Projets par Système",
    "dashboard.tickets.recent": "Tickets Récents",
    "dashboard.hardware.health": "Santé Matériel",
    "projects.title": "Projets",
    "projects.new": "Nouveau projet",
    "projects.columns.name": "Projet",
    "projects.columns.system": "Système",
    "projects.columns.site": "Site",
    "projects.columns.status": "Statut",
    "projects.columns.progress": "Progression",
    "projects.columns.engineer": "Lead",
    "tickets.title": "Support · Moteur IA",
    "tickets.new": "Nouveau ticket",
    "tickets.empty": "Aucun ticket — ouvrez votre première demande.",
    "tickets.form.subject": "Sujet",
    "tickets.form.body": "Décrivez le problème (technique, firmware, modèle, site).",
    "tickets.form.system": "Système",
    "tickets.form.priority": "Priorité",
    "tickets.form.language": "Langue de réponse",
    "tickets.form.submit": "Ouvrir · générer réponse IA",
    "tickets.ai_reply": "Réponse IA",
    "tickets.customer": "Client",
    "tickets.staff": "Staff",
    "tickets.reply": "Publier",
    "tickets.reply.placeholder": "Écrivez votre réponse…",
    "tickets.use_ai": "Réécrire avec l'IA",
    "hardware.title": "Parc Matériel",
    "hardware.new": "Nouvel équipement",
    "hardware.columns.vendor": "Fournisseur",
    "hardware.columns.model": "Modèle",
    "hardware.columns.serial": "Série",
    "hardware.columns.site": "Site",
    "hardware.columns.firmware": "Firmware",
    "hardware.columns.license": "Licence",
    "hardware.columns.status": "Statut",
    "calc.title": "Calculateur d'Infrastructure",
    "calc.subtitle": "Premium · Bande passante, stockage et puissance.",
    "calc.cameras": "Caméras",
    "calc.resolution": "Résolution",
    "calc.fps": "FPS",
    "calc.retention": "Rétention (jours)",
    "calc.compression": "Compression",
    "calc.radar": "Capteurs radar",
    "calc.readers": "Lecteurs d'accès",
    "calc.compute": "Calculer",
    "calc.gated": "Réservé aux clients Premium.",
    "calc.out.bandwidth": "Bande passante totale",
    "calc.out.storage": "Stockage sur rétention",
    "calc.out.power": "Puissance totale",
    "calc.out.switches": "Switchs PoE 24p",
    "docs.title": "Générateur de Documents",
    "docs.subtitle": "Rapports et plans en marque blanche.",
    "docs.type": "Type de document",
    "docs.type.commissioning": "Rapport de Commissioning Technique",
    "docs.type.blueprint": "Plan de Projet",
    "docs.generate": "Générer le PDF",
    "docs.download": "Télécharger",
    "common.operational": "Opérationnel",
    "common.warning": "Alerte",
    "common.critical": "Critique",
    "common.offline": "Hors ligne",
    "common.planning": "Planification",
    "common.in_progress": "En cours",
    "common.completed": "Terminé",
    "common.cancel": "Annuler",
    "common.save": "Enregistrer",
    "common.submit": "Envoyer",
    "common.language": "Langue",
    "renewals.title": "Pipeline de Renouvellement de Licences",
    "renewals.subtitle": "Devis automatiques et rappels par email 60 / 30 / 7 jours avant l'expiration de toute licence fournisseur.",
    "renewals.run": "Scanner et envoyer",
    "renewals.force": "Forcer renvoi",
    "renewals.send": "Envoyer",
    "renewals.assets": "actif(s)",
    "renewals.empty": "Aucun renouvellement à venir — toutes les licences sont à plus de 60 jours.",
    "renewals.tab.pipeline": "Pipeline",
    "renewals.tab.history": "Historique",
  },
  pt: {
    "nav.dashboard": "Centro de Comando",
    "nav.projects": "Projetos",
    "nav.tickets": "Suporte",
    "nav.hardware": "Inventário",
    "nav.calculator": "Calculadora",
    "nav.documents": "Documentos",
    "nav.renewals": "Renovações",
    "nav.login": "Entrar",
    "nav.signup": "Solicitar acesso",
    "nav.logout": "Sair",
    "landing.badge": "Operações de Engenharia · Controle de Acesso · VMS · Radar",
    "landing.hero.title": "O centro de comando operacional para integradores de segurança de alto padrão.",
    "landing.hero.subtitle": "B2BProblemSolver unifica acompanhamento de projetos, conformidade de hardware e suporte multilíngue com IA numa plataforma white-label — para equipes Kantech, Avigilon, Lenel OnGuard e Magos Radar de Santiago a Montreal.",
    "landing.cta.primary": "Entrar no Centro",
    "landing.cta.secondary": "Solicitar acesso",
    "landing.services.kicker": "Disciplinas",
    "landing.services.title": "Três sistemas. Uma cobertura operacional.",
    "landing.service.ac": "Controle de Acesso",
    "landing.service.ac.desc": "Implantações Kantech KT-400, KT-1, Lenel OnGuard, governança de firmware.",
    "landing.service.vms": "Gestão de Vídeo",
    "landing.service.vms.desc": "Implantações Avigilon ACC Enterprise, tuning de analíticos e modelagem de banda/armazenamento.",
    "landing.service.radar": "Radar Perimetral",
    "landing.service.radar.desc": "Integração Magos SR-500 / SR-1000 com controle de acesso e VMS.",
    "landing.presence.kicker": "Presença operacional",
    "landing.presence.title": "Continuidade de engenharia em quatro hubs.",
    "landing.features.kicker": "Módulos",
    "landing.feature1.title": "Centro de Comando do Cliente",
    "landing.feature1.desc": "Status de projetos em tempo real.",
    "landing.feature2.title": "Motor de Tickets com IA",
    "landing.feature2.desc": "Respostas Gemini-3 em 5 idiomas com manuais associados.",
    "landing.feature3.title": "Inventário de Hardware",
    "landing.feature3.desc": "Versões de firmware, licenças e saúde de cada ativo.",
    "landing.feature4.title": "Gerador de Documentos",
    "landing.feature4.desc": "Relatórios e Plantas em marca branca num clique.",
    "landing.feature5.title": "Calculadora de Infraestrutura",
    "landing.feature5.desc": "Banda, armazenamento e energia para qualquer frota.",
    "landing.feature6.title": "RBAC & Webhooks",
    "landing.feature6.desc": "Níveis Standard/Premium com hooks de API.",
    "landing.footer": "B2BProblemSolver LLC · Sistemas projetados para continuidade.",
    "auth.login.title": "Entrar no Centro",
    "auth.login.subtitle": "Acesso seguro para staff, contratados e clientes.",
    "auth.email": "E-mail",
    "auth.password": "Senha",
    "auth.signin": "Entrar",
    "auth.google": "Continuar com Google (Corporativo)",
    "auth.noaccount": "Sem conta?",
    "auth.register": "Solicitar acesso",
    "auth.haveaccount": "Já é cliente?",
    "auth.name": "Nome completo",
    "auth.company": "Empresa",
    "auth.register.title": "Solicitar acesso à plataforma",
    "auth.register.subtitle": "Crie uma conta para abrir tickets e baixar documentação.",
    "auth.register.submit": "Criar conta",
    "dashboard.title": "Centro de Comando",
    "dashboard.subtitle": "Instantâneo operacional ao vivo.",
    "dashboard.kpi.projects": "Projetos Ativos",
    "dashboard.kpi.tickets": "Tickets",
    "dashboard.kpi.assets": "Ativos",
    "dashboard.kpi.critical": "Alertas Críticos",
    "dashboard.projects.recent": "Projetos por Sistema",
    "dashboard.tickets.recent": "Tickets Recentes",
    "dashboard.hardware.health": "Saúde de Hardware",
    "projects.title": "Projetos",
    "projects.new": "Novo projeto",
    "projects.columns.name": "Projeto",
    "projects.columns.system": "Sistema",
    "projects.columns.site": "Local",
    "projects.columns.status": "Status",
    "projects.columns.progress": "Progresso",
    "projects.columns.engineer": "Líder",
    "tickets.title": "Suporte · Motor de IA",
    "tickets.new": "Novo ticket",
    "tickets.empty": "Sem tickets — abra o primeiro.",
    "tickets.form.subject": "Assunto",
    "tickets.form.body": "Descreva o problema (técnico, firmware, modelo, local).",
    "tickets.form.system": "Sistema",
    "tickets.form.priority": "Prioridade",
    "tickets.form.language": "Idioma da resposta",
    "tickets.form.submit": "Abrir · gerar resposta IA",
    "tickets.ai_reply": "Resposta IA",
    "tickets.customer": "Cliente",
    "tickets.staff": "Staff",
    "tickets.reply": "Publicar resposta",
    "tickets.reply.placeholder": "Escreva sua resposta…",
    "tickets.use_ai": "Reescrever com IA",
    "hardware.title": "Inventário de Hardware",
    "hardware.new": "Novo ativo",
    "hardware.columns.vendor": "Fabricante",
    "hardware.columns.model": "Modelo",
    "hardware.columns.serial": "Serial",
    "hardware.columns.site": "Local",
    "hardware.columns.firmware": "Firmware",
    "hardware.columns.license": "Licença",
    "hardware.columns.status": "Status",
    "calc.title": "Calculadora de Infraestrutura",
    "calc.subtitle": "Premium · Banda, armazenamento e energia.",
    "calc.cameras": "Câmeras",
    "calc.resolution": "Resolução",
    "calc.fps": "FPS",
    "calc.retention": "Retenção (dias)",
    "calc.compression": "Compressão",
    "calc.radar": "Sensores radar",
    "calc.readers": "Leitores",
    "calc.compute": "Calcular",
    "calc.gated": "Apenas clientes Premium.",
    "calc.out.bandwidth": "Banda total",
    "calc.out.storage": "Armazenamento por retenção",
    "calc.out.power": "Potência total",
    "calc.out.switches": "Switches PoE 24p",
    "docs.title": "Gerador de Documentos",
    "docs.subtitle": "Relatórios e plantas em marca branca.",
    "docs.type": "Tipo de documento",
    "docs.type.commissioning": "Relatório Técnico de Comissionamento",
    "docs.type.blueprint": "Planta do Projeto",
    "docs.generate": "Gerar PDF",
    "docs.download": "Baixar",
    "common.operational": "Operacional",
    "common.warning": "Atenção",
    "common.critical": "Crítico",
    "common.offline": "Offline",
    "common.planning": "Planejamento",
    "common.in_progress": "Em andamento",
    "common.completed": "Concluído",
    "common.cancel": "Cancelar",
    "common.save": "Salvar",
    "common.submit": "Enviar",
    "common.language": "Idioma",
    "renewals.title": "Pipeline de Renovação de Licenças",
    "renewals.subtitle": "Cotações automáticas e e-mails de aviso 60 / 30 / 7 dias antes do vencimento de cada licença.",
    "renewals.run": "Escanear e enviar",
    "renewals.force": "Reenviar",
    "renewals.send": "Enviar",
    "renewals.assets": "ativo(s)",
    "renewals.empty": "Sem renovações próximas — todas as licenças têm mais de 60 dias de vigência.",
    "renewals.tab.pipeline": "Pipeline",
    "renewals.tab.history": "Histórico",
  },
  ht: {
    "nav.dashboard": "Sant Kòmandman",
    "nav.projects": "Pwojè",
    "nav.tickets": "Sipò",
    "nav.hardware": "Ekipman",
    "nav.calculator": "Kalkilatè",
    "nav.documents": "Dokiman",
    "nav.renewals": "Renouvèlman",
    "nav.login": "Konekte",
    "nav.signup": "Mande aksè",
    "nav.logout": "Dekonekte",
    "landing.badge": "Operasyon Jeni · Kontwòl Aksè · VMS · Rada",
    "landing.hero.title": "Sant kòmandman operasyonèl pou entegratè sekirite wo nivo.",
    "landing.hero.subtitle": "B2BProblemSolver rasanble swivi pwojè, konfòmite materyèl ak sipò IA miltilang nan yon sèl platfòm mak blan — pou ekip Kantech, Avigilon, Lenel OnGuard ak Magos Radar soti Santiago rive Monreyal.",
    "landing.cta.primary": "Antre nan Sant la",
    "landing.cta.secondary": "Mande aksè",
    "landing.services.kicker": "Disiplin",
    "landing.services.title": "Twa sistèm. Yon kouveti operasyonèl.",
    "landing.service.ac": "Kontwòl Aksè",
    "landing.service.ac.desc": "Deplwaman Kantech KT-400, KT-1, Lenel OnGuard ak gouvènans firmware.",
    "landing.service.vms": "Jesyon Videyo",
    "landing.service.vms.desc": "Deplwaman Avigilon ACC Enterprise ak analitik.",
    "landing.service.radar": "Rada Perimèt",
    "landing.service.radar.desc": "Entegrasyon Magos SR-500 / SR-1000 ak kontwòl aksè.",
    "landing.presence.kicker": "Prezans operasyonèl",
    "landing.presence.title": "Kontinwite jeni nan kat lokasyon.",
    "landing.features.kicker": "Modil",
    "landing.feature1.title": "Sant Kòmandman Kliyan",
    "landing.feature1.desc": "Estati pwojè an tan reyèl.",
    "landing.feature2.title": "Motè IA pou tikè",
    "landing.feature2.desc": "Repons Gemini-3 nan 5 lang ak manyèl otomatik.",
    "landing.feature3.title": "Ekipman",
    "landing.feature3.desc": "Vèsyon firmware, ekspirasyon lisans ak sante aktif.",
    "landing.feature4.title": "Jeneratè Dokiman",
    "landing.feature4.desc": "Rapò ak plan pwojè mak blan an yon klik.",
    "landing.feature5.title": "Kalkilatè Enfrastrikti",
    "landing.feature5.desc": "Bann pasaj, depo ak enèji.",
    "landing.feature6.title": "RBAC & Webhooks",
    "landing.feature6.desc": "Nivo Standard ak Premium ak API.",
    "landing.footer": "B2BProblemSolver LLC · Sistèm konstwi pou kontinwite.",
    "auth.login.title": "Konekte nan Sant la",
    "auth.login.subtitle": "Aksè sekirize pou staff ak kliyan.",
    "auth.email": "Imèl",
    "auth.password": "Modpas",
    "auth.signin": "Konekte",
    "auth.google": "Kontinye ak Google (Antrepriz)",
    "auth.noaccount": "Pa gen kont?",
    "auth.register": "Mande aksè",
    "auth.haveaccount": "Ou se yon kliyan?",
    "auth.name": "Non konplè",
    "auth.company": "Konpayi",
    "auth.register.title": "Mande aksè nan platfòm lan",
    "auth.register.subtitle": "Kreye yon kont pou ouvè tikè ak telechaje dokiman.",
    "auth.register.submit": "Kreye kont",
    "dashboard.title": "Sant Kòmandman",
    "dashboard.subtitle": "Foto operasyonèl an tan reyèl.",
    "dashboard.kpi.projects": "Pwojè Aktif",
    "dashboard.kpi.tickets": "Tikè",
    "dashboard.kpi.assets": "Ekipman",
    "dashboard.kpi.critical": "Alèt Kritik",
    "dashboard.projects.recent": "Pwojè pa Sistèm",
    "dashboard.tickets.recent": "Tikè Resan",
    "dashboard.hardware.health": "Sante Ekipman",
    "projects.title": "Pwojè",
    "projects.new": "Nouvo pwojè",
    "projects.columns.name": "Pwojè",
    "projects.columns.system": "Sistèm",
    "projects.columns.site": "Sit",
    "projects.columns.status": "Estati",
    "projects.columns.progress": "Pwogrè",
    "projects.columns.engineer": "Lidè",
    "tickets.title": "Sipò · Motè IA",
    "tickets.new": "Nouvo tikè",
    "tickets.empty": "Pa gen tikè — kreye premye a.",
    "tickets.form.subject": "Sijè",
    "tickets.form.body": "Dekri pwoblèm nan (teknik).",
    "tickets.form.system": "Sistèm",
    "tickets.form.priority": "Priyorite",
    "tickets.form.language": "Lang repons",
    "tickets.form.submit": "Ouvè tikè · jenere repons IA",
    "tickets.ai_reply": "Repons IA",
    "tickets.customer": "Kliyan",
    "tickets.staff": "Staff",
    "tickets.reply": "Voye repons",
    "tickets.reply.placeholder": "Ekri repons ou…",
    "tickets.use_ai": "Rekri ak IA",
    "hardware.title": "Ekipman",
    "hardware.new": "Nouvo aktif",
    "hardware.columns.vendor": "Machann",
    "hardware.columns.model": "Modèl",
    "hardware.columns.serial": "Seri",
    "hardware.columns.site": "Sit",
    "hardware.columns.firmware": "Firmware",
    "hardware.columns.license": "Lisans",
    "hardware.columns.status": "Estati",
    "calc.title": "Kalkilatè Enfrastrikti",
    "calc.subtitle": "Premium · Bann pasaj, depo ak enèji.",
    "calc.cameras": "Kamera",
    "calc.resolution": "Rezolisyon",
    "calc.fps": "FPS",
    "calc.retention": "Retansyon (jou)",
    "calc.compression": "Konpresyon",
    "calc.radar": "Sansè rada",
    "calc.readers": "Lektè aksè",
    "calc.compute": "Kalkile",
    "calc.gated": "Sèlman pou kliyan Premium.",
    "calc.out.bandwidth": "Bann pasaj total",
    "calc.out.storage": "Depo pa retansyon",
    "calc.out.power": "Enèji total",
    "calc.out.switches": "Switch PoE 24p",
    "docs.title": "Jeneratè Dokiman",
    "docs.subtitle": "Rapò ak plan mak blan.",
    "docs.type": "Tip dokiman",
    "docs.type.commissioning": "Rapò Teknik Komisyonman",
    "docs.type.blueprint": "Plan Pwojè",
    "docs.generate": "Jenere PDF",
    "docs.download": "Telechaje",
    "common.operational": "Operasyonèl",
    "common.warning": "Avètisman",
    "common.critical": "Kritik",
    "common.offline": "Offline",
    "common.planning": "Planifikasyon",
    "common.in_progress": "An kou",
    "common.completed": "Fini",
    "common.cancel": "Anile",
    "common.save": "Sove",
    "common.submit": "Voye",
    "common.language": "Lang",
    "renewals.title": "Pipeline Renouvèlman Lisans",
    "renewals.subtitle": "Devi otomatik ak imèl rapèl 60 / 30 / 7 jou anvan ekspirasyon nenpòt lisans.",
    "renewals.run": "Eskane epi voye",
    "renewals.force": "Fòse re-voye",
    "renewals.send": "Voye",
    "renewals.assets": "aktif",
    "renewals.empty": "Pa gen renouvèlman pwochen — tout lisans yo gen plis pase 60 jou.",
    "renewals.tab.pipeline": "Pipeline",
    "renewals.tab.history": "Istwa",
  },
};

export default T;
